import styled from "styled-components";

export const LeftSideBarWrapper = styled.div`
  display: flex;
  flex-grow: 0.6;
  flex-shrink: 1;
  flex-direction: column;
  align-items: flex-start;
  height: 100vh;
  background-color: #fff;
  flex-basis: 0;
`;
